import {StoppageInfoDto, StoppageInfo} from '@domain/stoppages'
import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

export const QueryKey = 'stoppages-suggestions'

export const useGetStoppagesSuggestions = (
  plantUpmId: string,
  options?: UseQueryOptions<StoppageInfoDto[], AxiosError, StoppageInfo[]>
) => {
  return useQuery<StoppageInfoDto[], AxiosError, StoppageInfo[]>({
    queryKey: [QueryKey, plantUpmId],
    queryFn: async () => {
      const path = '/rootcausefailureanalysis/stoppages/without-analysis'
      return (await ApiClient.axiosInstance.get<StoppageInfoDto[]>(path, {params: {plantUpmId}}))
        .data
    },
    // these default values will get moved to the api provider soon
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    throwOnError: true,
    retry: false,
    enabled: Boolean(plantUpmId),

    // allow the callee to override the default options
    ...options,
    select: (data) =>
      data.map((stoppage) => ({
        ...stoppage,
        id: stoppage.externalGroupId ?? stoppage.externalMainId
      }))
  })
}
